import { useState, useEffect, useContext } from 'react';

import Loading from "../../components/Loading";
import AppContext from "../../../context";

import Item from './components/Item';

import Data from "../../../repository/index";

import styles from "../../../styles/Admin.module.scss";

function Transactions() {
	const context = useContext(AppContext);
	const [loading, setLoading] = useState(true);
	const [transactions, setTransactions] = useState([]);
	const isHybrid = context.domain?.businessType === 'hybrid' || context.domain?.businessType === 'hybrid-new';

	useEffect(async () => {
		let transactions = isHybrid ? await Data.fetchWalletTransactions() : await Data.fetchTransactions();
		transactions = transactions.data.sort((a, b) => {
			return new Date(b.createdAt) - new Date(a.createdAt);
		})
		setTransactions(transactions);
		setLoading(false);
	}, [])

	if(loading) return <Loading button={false} />

	return (
		<div className={styles.list}>
			{!transactions.length && <div><p>There aren't any transactions to show.</p></div>}

			{transactions.map((transaction) => {
				return <Item {...transaction} />
			})}
		</div>
	)
}

export default Transactions;
